export const GenerateId = (id: string, index: number): string => {
  return `${id}-tab-${index}`;
};
